module.exports = __webpack_public_path__ + "static/media/writer.741459c1.jpg";